import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import BucketRepository from "../../repositories/BucketRepository";

interface props { bucketRepository: BucketRepository }

@injectable()
export default class MoveUserToBucketUseCase {
    _bucketRepository: BucketRepository;

    constructor(_: props) {
        this._bucketRepository = _.bucketRepository;
    }

    public call = async (userId: string, location: string, client: string, supervisor: string): Promise<Either<ExceptionEntity, string>> => {
        return await this._bucketRepository.moveUserToBucket(userId, location, client, supervisor);
    }
}

export const MoveUserToBucketUseCaseName = "MoveUserToBucketUseCaseName";
